module.exports = __webpack_public_path__ + "static/img/why-1.13b21c47.jpg";